import { PricingRowDto } from "../pricing/PricingRow"
import { GroupDto } from "../pricing/Group"
import { PricingTotalDto } from "../pricing/PricingTotals"
import { ORDERS } from "./Constants"

type OrderDtoAttributes = {
    identifier: string,
    items: PricingRowDto[]
    groups: GroupDto[]
    totals: PricingTotalDto[]
    pricingTableId: string
    status: string
    isWorkflowLoading: boolean
}

export type OrderDto = {
    id: string,
    type: typeof ORDERS,
    attributes: OrderDtoAttributes
}


export type CreateOrderDto = {
    sellerId: string,
    projectId: string,
    contactId: string,
    quoteReferenceId: string,
    locationId: string,
    creditMemoIdsToApply?: string[],
    reference?: object,
    rows?: object,
    identifier?: string,
}

export type DuplicateOrderDto = {
    contactId: string,
    locationId: string,
}

export default class Order {
    private dto: OrderDto
    constructor(dto: OrderDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "orders"
    }

    getId(): string {
        return this.dto.id
    }

    getItems(): PricingRowDto[] {
        return this.dto.attributes.items
    }
}


// WEBPACK FOOTER //
// ./src/state/order/Order.ts